// Core
import { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ChakraProvider, Portal, useDisclosure, useColorModeValue } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../theme/theme.js';

// Components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import Navbar from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';

export default function Dashboard(props) {
  const { ...rest } = props;

  const [ fixed, setFixed ] = useState(false);
  const [ isSidebarStack, setSidebarStack ] = useState(false);

  const [ pagePlay, setPagePlay ] = useState(false);
  const [ activeModel, setActiveModel ] = useState(parseInt(localStorage.getItem('activeModel'), 10) || 0);
  const [ sessionTokens, setSessionTokens ] = useState(0);
  const [ isClaim, setIsClaim ] = useState(false); 
  const [ activeBuyPopup, setActiveBuyPopup ] = useState(false);
  const [tokens, setTokens] = useState(localStorage.getItem('tokens') || 0);

  const getRoute = () => {
    return window.location.pathname !== '/full-screen-maps';
  };

  const getActiveRoute = (routes) => {
    const activeRoute = '';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        const categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    const activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        const categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/') {
        /*return <Route 
          path={prop.layout + prop.path}
          component={prop.component} 
          key={key} 
          routes={routes} 
          pagePlay={pagePlay}
          setPagePlay={setPagePlay}
          sessionTokens={sessionTokens}
          setSessionTokens={setSessionTokens}
        />;*/
        return <Route path={prop.layout + prop.path} key={key}>
          { routerProps => 
              <prop.component {...routerProps}
                isClaim={isClaim}
                setIsClaim={setIsClaim}
                pagePlay={pagePlay}
                activeModel={activeModel}
                setActiveModel={setActiveModel}
                setPagePlay={setPagePlay}
                tokens={tokens}
                setTokens={setTokens}
                sessionTokens={sessionTokens}
                setSessionTokens={setSessionTokens} />
          }
        </Route>;

      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Chakra Color Mode
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <MainPanel
        transition='unset !important'
        w={{ base: '100%' }}
        left={{ base: '0' }}
        maxWidth="1440px"
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto 0 auto"
      >
        <Portal>
          <Navbar
            routes={routes}
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            setActiveBuyPopup={setActiveBuyPopup}
            isClaim={isClaim}
            activeModel={activeModel}
            setActiveModel={setActiveModel}
            pagePlay={pagePlay}
            setPagePlay={setPagePlay}
            tokens={tokens}
            setTokens={setTokens}
            sessionTokens={sessionTokens}
            {...rest}
          />
        </Portal>
        { getRoute() ? (
          <PanelContent>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from='/' to={routes[0].path} />
              </Switch>
            </PanelContainer>
          </PanelContent>
        ) : null}
        <Footer
          tokens={tokens}
          setTokens={setTokens}
          activeModel={activeModel}
          setActiveModel={setActiveModel}
          activeBuyPopup={activeBuyPopup}
          setActiveBuyPopup={setActiveBuyPopup}
        />
      </MainPanel>
    </ChakraProvider>
  );
}
